<template>
  <div class="flex items-center space-x-2">
    <Icon v-if="icon" :icon="icon" :class="iconClass" />
    <component
      :is="props.breadcrumbHeadingTag || `h${level}`"
      :class="[headingBase, $attrs.class, props.color]"
    >
      <slot />
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Icon from '../atom/icon.vue'
import type { HeadingProps } from '~~/shared/types/common'

const props = withDefaults(defineProps<HeadingProps>(), {
  color: 'text-black',
  breadcrumbHeadingTag:""
})

const headingStyles: Record<number, string> = {
  1: 'text-[3.7142857rem] font-normal leading-[110%] tracking-[-0.035714rem]',
  2: 'text-[3.142857rem] font-normal leading-[110%] tracking-[-0.035714rem]',
  3: 'text-[2.225714rem] font-normal leading-[110%] tracking-[-0.035714rem]',
  4: 'text-[1.7142857rem] font-normal leading-[110%] tracking-[-0.035714rem]',
  5: 'text-[1.428571rem] font-normal leading-[120%] tracking-[-0.035714rem]',
  6: 'text-[0.764286rem] font-medium leading-normal',
}

const headingBase = computed(() => headingStyles[props.level])
const level = computed(() => props.level)
</script>
